import React, { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export type Props = {
  children: ReactNode;
  title: string;
};

export const SeeAllHeader = ({ children, title }: Props) => {
  return (
    <div
      className={clsx(
        'col-md-12 col-lg-3 pr-lg-0 d-sm-flex d-lg-block justify-content-between align-baseline pt-4 mt-0 mt-lg-2',
        styles.seeAllHeader,
      )}
    >
      <h1 className={clsx('flex-fill m-0 mr-1', styles.title)}>{title}</h1>
      {children}
    </div>
  );
};
